/* =========================================================
   76 West Boot Co — Storefront JS (Shopify theme port)
   Scoped to [data-store="76west"]. Vanilla JS only, no build
   step, no framework.

   PORTED: mock cart counter + mock newsletter submit have been
   replaced with real Shopify Ajax Cart API calls per
   references/commerce-bindings.md. Newsletter now submits a
   real Liquid {% form 'customer' %} (native browser POST,
   progressively enhanced below only for the success message).
   ========================================================= */
(function () {
  "use strict";

  var storeRoots = document.querySelectorAll('[data-store="76west"]');
  if (!storeRoots.length) return;
  // NOTE: each ported section renders its own top-level <div data-store="76west">
  // wrapper, so the page contains MANY sibling elements matching this selector
  // (one per section), not a single page-wide wrapper. Anything scoped to a
  // single querySelector("[data-store=...]") result silently only affects the
  // first section in DOM order. Page-wide behaviors below intentionally use
  // `document` (scoped by data attributes like [data-reveal], [data-product-form],
  // .newsletter-form, .toast, [data-cart-count]) instead of a single "root".

  /* ---------------- Mobile nav toggle ---------------- */
  storeRoots.forEach(function (sectionRoot) {
    var menuToggle = sectionRoot.querySelector(".menu-toggle");
    var mobileNav = sectionRoot.querySelector(".mobile-nav");
    if (menuToggle && mobileNav) {
      menuToggle.addEventListener("click", function () {
        var isOpen = mobileNav.classList.toggle("is-open");
        menuToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        menuToggle.textContent = isOpen ? "Close" : "Menu";
      });
    }
  });

  /* ---------------- Reveal-on-scroll ---------------- */
  var revealEls = document.querySelectorAll('[data-store="76west"] [data-reveal]');
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------------- Real cart: count badge ---------------- */
  var cartCountEls = document.querySelectorAll("[data-cart-count]");

  function refreshCartCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCountEls.forEach(function (el) {
          el.textContent = String(cart.item_count);
        });
      })
      .catch(function () { /* silent fail, badge just keeps last known value */ });
  }

  function showToast(message) {
    var toast = document.querySelector(".toast");
    if (!toast) return;
    toast.querySelector(".toast__msg").textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(toast._hideTimer);
    toast._hideTimer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 2400);
  }

  /* ---------------- Real add-to-cart: intercept product forms ---------------- */
  // Every product card renders a real {% form 'product', product %} (see
  // snippets/76w-product-card.liquid). We progressively enhance the submit
  // with an AJAX POST to /cart/add.js so the page doesn't hard-navigate;
  // if JS fails, the form still submits natively to /cart/add and works.
  document.addEventListener("submit", function (evt) {
    var form = evt.target.closest("[data-product-form]");
    if (!form) return;
    evt.preventDefault();

    var submitBtn = form.querySelector("[data-add-to-cart]");
    if (submitBtn && submitBtn.disabled) return;

    var formData = new FormData(form);
    var payload = {
      id: formData.get("id"),
      quantity: Number(formData.get("quantity")) || 1,
    };

    if (submitBtn) submitBtn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (item) {
        refreshCartCount();
        var title = (submitBtn && submitBtn.getAttribute("data-product-title")) || item.product_title || "Item";
        showToast(title + " added to cart");
        document.dispatchEvent(
          new CustomEvent("cart:add", { detail: { id: payload.id, quantity: payload.quantity, item: item } })
        );
      })
      .catch(function (err) {
        var message = (err && err.description) || "Couldn't add that to your cart — it may be sold out.";
        showToast(message);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  /* ---------------- Newsletter: real Shopify customer form ---------------- */
  // The form itself is a real {% form 'customer' %} (see sections/76w-newsletter.liquid)
  // that posts contact[email] + contact[tags]=newsletter. This progressive-enhancement
  // layer only prevents a full page reload when JS is available; the native form action
  // still works with JS disabled and Shopify renders form.posted_successfully? server-side.
  var newsletterForms = document.querySelectorAll(".newsletter-form");
  newsletterForms.forEach(function (form) {
    form.addEventListener("submit", function (evt) {
      var input = form.querySelector('input[type="email"]');
      if (!input || !input.value) {
        evt.preventDefault();
        return;
      }
      // Let the real Shopify customer form submission proceed (no preventDefault):
      // Shopify will redirect back to this page with form.posted_successfully? = true,
      // which sections/76w-newsletter.liquid renders as the success message.
    });
  });

  /* ---------------- PLP: native Shopify sort/filter ---------------- */
  // Sort-by and collection filters are now real Shopify collection controls
  // (sections/76w-main-collection.liquid submits ?sort_by= and uses
  // collection.filters url_to_add/url_to_remove) — no client-side DOM
  // reordering needed; the browser navigates with real query params.

  refreshCartCount();
})();
